// eslint-disable-next-line no-unused-vars

import {
    dataStepFinder,
    deviceStepFinder,
    voiceStepFinder,
} from "./StepFinders";
import { getUpfrontPaymentOptions } from "./UpfrontPaymentOptionsCalculator";
import myFlexiPlanSteps from "../enums/myFlexiPlanSteps";

export const getDeviceCostPerMonth = (
    device,
    upfrontPurchaseAmount,
    contractDuration
) => {
    const flexiPlanPrice = device.Specifications["MyFlexiPlan Purchase Amount"];

    if (!flexiPlanPrice) {
        throw new Error(
            `${device.Name} is missing the MyFlexiPlan Purchase Amount` +
                " specification"
        );
    }
    return +(
        (+flexiPlanPrice - upfrontPurchaseAmount) /
        contractDuration
    ).toFixed(2);
};

export const calculateMonthlyFee = (
    flow,
    upfrontPurchaseAmount,
    contractDuration
) => {
    const deviceStep = deviceStepFinder(flow);
    let deviceMonthlyCost = 0;
    if (deviceStep && deviceStep.selectedItem) {
        if (!contractDuration || !upfrontPurchaseAmount) {
            return NaN;
        }
        deviceMonthlyCost = getDeviceCostPerMonth(
            deviceStep.selectedItem,
            upfrontPurchaseAmount,
            contractDuration
        );
    }

    const voice = voiceStepFinder(flow);
    const voiceMonthlyCost = voice
        ? voice.selectedItem
            ? voice.selectedItem.Specifications[`Monthly Price`]
            : 0
        : 0;

    const data = dataStepFinder(flow);
    const dataMonthlyCost = data
        ? data.selectedItem
            ? data.selectedItem.Specifications[`Monthly Price`]
            : 0
        : 0;

    return +(+deviceMonthlyCost + +voiceMonthlyCost + +dataMonthlyCost).toFixed(
        2
    );
};

export const getMinimumMonthlyPrice = (product) => {
    const paymentOptions = getUpfrontPaymentOptions(product);
    const lastPaymentOption = paymentOptions[paymentOptions.length - 1];
    const maxMonthsToPay = 24;
    const flow = [
        {
            name: myFlexiPlanSteps.device.name,
            selectedItem: product,
        },
    ];
    return calculateMonthlyFee(flow, lastPaymentOption, maxMonthsToPay);
};
